/* BETALUMINA_PWA_VIEWPORT_LOCK_R4 */
import "./blockPullToRefresh.css";

const SHELL_CLASS = "betalumina-pwa-viewport-lock";
const VERSION = "BETALUMINA-PULL-TO-REFRESH-R4-20260818";

let observer = null;

function dashboardIsMounted() {
  return Boolean(document.querySelector(".dashboard-container"));
}

function applyState() {
  if (!document.documentElement || !document.body) return;

  const active = dashboardIsMounted();

  document.documentElement.classList.toggle(SHELL_CLASS, active);
  document.body.classList.toggle(SHELL_CLASS, active);

  window.__BETALUMINA_PULL_TO_REFRESH_R4__ = {
    version: VERSION,
    active,
    displayModeStandalone:
      window.matchMedia?.("(display-mode: standalone)")?.matches === true,
    updatedAt: new Date().toISOString(),
  };
}

function installViewportLock() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  applyState();

  if (observer) return;

  observer = new MutationObserver(applyState);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.addEventListener("pageshow", applyState, { passive: true });
  window.addEventListener("resize", applyState, { passive: true });
}

installViewportLock();
